import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import VideoCard from "./VideoCard";

const styles = {
  list: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
  },
};

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pages: null,
      currentPage: 1,
    };
  }

  componentDidMount = () => {
    const { videos, videoLimit } = this.props;

    let intPages = Math.round(videos.length / videoLimit);

    if (videos.length % videoLimit !== 0) {
      return this.setState({
        pages: intPages + 1
      });
    } else {
      return this.setState({
        pages: intPages
      });
    }
  };

  goToNextPage = () => {
    this.setState({
      currentPage: this.state.currentPage + 1,
    });
  }

  goToLastPage = () => {
    this.setState({
      currentPage: this.state.pages,
    });
  }

  goToFirstPage = () => {
    this.setState({
      currentPage: 1,
    });
  }

  goToPreviousPage = () => {
    this.setState({
      currentPage: this.state.currentPage - 1,
    });
  }

  changePage = (e) => {
    const pageNumber = Number(e.target.textContent);

    this.setState({
      currentPage: pageNumber,
    });
  }

  getPaginatedData = () => {
    const startIndex = this.state.currentPage * this.props.videoLimit - this.props.videoLimit;
    const endIndex = startIndex + this.props.videoLimit;

    return this.props.videos.slice(startIndex, endIndex);
  };

  getPaginationGroup = () => {
    let start = Math.floor((this.state.currentPage - 1) / this.props.pageLimit) * this.props.pageLimit;

    return new Array(this.props.pageLimit).fill().map((_, idx) => start + idx + 1);
  };

  handleOnEvaluate = (video) => {
    this.props.history.push({
      pathname: `/pitchs/${video.id}`
    });
  };
  
  handleOnCheck = (video) => {
    this.props.history.push({
      pathname: `/pitchs/${video.id}/feedback`
    });
  };

  handleOnEdit = ({ id, title, description }) => {
    this.props.history.push({
      pathname: `/pitchs/${id}/edit`,
      search: "?",
      state: {
        video: {
          id: id,
          title: title,
          description: description
        }
      }
    });
  };

  renderVideo = ({id, userId, transcodedUrl, thumbnail, title, description, createdAt, userName, userAvatar}) => {
    const {
      isVideoCardShareable,
      isSpeechEvaluable,
      isEvaluationCheckable,
      currentUser
    } = this.props;

    return (
      <VideoCard
        currentUser={currentUser}
        owner={userId}
        videoId={id}
        userName={userName}
        userAvatar={userAvatar}
        key={id}
        thumbnail={thumbnail}
        src={transcodedUrl}
        shareUrl={`https://sirena-startup.netlify.app/pitchs/${id}`}
        title={title}
        createdAt={createdAt}
        onEvaluate={() => this.handleOnEvaluate({ id, transcodedUrl })}
        onCheck={() => this.handleOnCheck({ id })}
        onEditClick={() => this.handleOnEdit({ id, title, description })}
        isShareable={isVideoCardShareable}
        isEvaluable={isSpeechEvaluable}
        isCheckable={isEvaluationCheckable}
      />
    );
  }

  render() {
    return(
      <div>
        <div className="dataContainer" style={styles.list}>
          {this.getPaginatedData().map((video, idx) => (
            this.renderVideo(video)
          ))}
        </div>
        {
          this.props.pageLimit === 0 
            ? null 
            : (
              <div className="pagination">
                {/* first button */}
                <button
                  onClick={this.goToFirstPage}
                  className={`prev ${this.state.currentPage === 1 ? 'disabled' : ''}`}
                >
                  first
                </button>

                {/* previous button */}
                <button
                  onClick={this.goToPreviousPage}
                  className={`prev ${this.state.currentPage === 1 ? 'disabled' : ''}`}
                >
                  {"<<"}
                </button>
          
                {/* show page / pages */}
                {this.getPaginationGroup().map((item, index) => (
                  <button
                    key={index}
                    onClick={this.changePage}
                    className={`paginationItem ${this.state.currentPage === item ? 'active' : null}`}
                  >
                    <span>{item + ' / ' + this.state.pages}</span>
                  </button>
                ))}
          
                {/* next button */}
                <button
                  onClick={this.goToNextPage}
                  className={`next ${this.state.currentPage === this.state.pages ? 'disabled' : ''}`}
                >
                  {">>"}
                </button>
          
                {/* last button */}
                <button
                  onClick={this.goToLastPage}
                  className={`next ${this.state.currentPage === this.state.pages ? 'disabled' : ''}`}
                >
                  last
                </button>
              </div>
            )
        }
      </div>
    );
  }
}

Pagination.propTypes = {
  isVideoCardShareable: PropTypes.bool,
  isEvaluationCheckable: PropTypes.bool,
  currentUser: PropTypes.string.isRequired,
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      transcodedUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      userName: PropTypes.string.isRequired,
      userAvatar: PropTypes.string
    })
  ).isRequired
};

Pagination.defaultProps = {
  isVideoCardShareable: false,
  isSpeechEvaluable: false
};

export default withRouter(Pagination);
